import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

export interface SquareEntry {
  selectionId: string;
  userId: string;
  username: string;
  ssoUserId?: string;
  optionId: string;
  squareNumber: number | null;
  rowIndex: number | null;
  colIndex: number | null;
  rowDigit: number | null;
  colDigit: number | null;
  isWinner: boolean;
  prizeAmountsByPeriod: Record<string, number>;
  createdAt: string | null;
}

export interface GetEntriesResponse {
  questionId: string;
  entries: SquareEntry[];
  totalEntries: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface GetEntriesParams {
  page?: number;
  limit?: number;
  search?: string;
}

export async function getEntries(
  squareId: string,
  params?: GetEntriesParams
): Promise<GetEntriesResponse> {
  const queryParams = new URLSearchParams();
  if (params?.page !== undefined) queryParams.set('page', String(params.page));
  if (params?.limit !== undefined) queryParams.set('limit', String(params.limit));
  if (params?.search) queryParams.set('search', params.search);

  const qs = queryParams.toString();
  const url = `/api/admin/squares/${squareId}/entries${qs ? `?${qs}` : ''}`;
  const response = await (apiClient as any).get(url);
  return response as GetEntriesResponse;
}

export function useGetEntriesQuery(squareId: string | null, params?: GetEntriesParams) {
  return useQuery<GetEntriesResponse>({
    queryKey: queryKeys.squares.entries(squareId, params),
    queryFn: () => getEntries(squareId!, params),
    enabled: !!squareId,
  });
}
